export enum BeneficiaryStatusFilter {
	ACTIVE = 'active',
	EXCLUSION = 'exclusion',
	INACTIVE = 'inactive',
	INCLUSION = 'inclusion',
}
